import {
    GET_PAYMENT_BEGIN,
    GET_PAYMENT_SUCCESS,
    GET_PAYMENT_FAILURE
} from '../constants'
import {ACTION_STATE} from '../../../common/Utilities'

export function reducer(state, action) {
    switch (action.type) {
        case GET_PAYMENT_BEGIN:
            return {
                ...state,
                paymentsState: ACTION_STATE.PENDING,
            }
        case GET_PAYMENT_SUCCESS:
            return {
                ...state,
                paymentsState: ACTION_STATE.SUCCESS,
                originalPaymentsData: action.data.originalPaymentsData
            }
        case GET_PAYMENT_FAILURE:
            return {
                ...state,
                paymentsState: ACTION_STATE.ERROR,
                paymentsError: action.data.paymentsError
            }
        default:
            return state
    }
}
